export const certifications = [
    {
        Institution: "Edutechs",
        certificate: "Software Engineer",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQITh5cwD-2krO2um3BVol3kJnjk9LGIVL0NA&s",
        Issued: "Oct 2025-Present",
    },
    {
        Institution: "MoveOn Technologies Ltd",
        certificate: "Software Engineer",
        logo: "https://content.easy.jobs/assets/201536/company_logo.png",
        Issued: "Aug 2023-Dec 2023",
    },
    {
        Institution: "AlgoExpert",
        certificate: "AlgoExpert Coding Interview Questions",
        logo: "https://i.imgur.com/wZcehJh.png",
        Issued: "May 19, 2023",
    },
    {
        Institution: "East West University",
        certificate: "Bachelor in CSE",
        logo: "https://i.imgur.com/ptq7E9Q.jpg",
        Issued: "2015-2022",
    },
    {
        Institution: "freeCodeCamp",
        certificate: "JS Algorithms and Data Structures",
        logo: "https://i.imgur.com/1FWhJeT.png",
        Issued: "December 9, 2020",
    },
    {
        Institution: "freeCodeCamp",
        certificate: "Responsive Web Design",
        logo: "https://i.imgur.com/1FWhJeT.png",
        Issued: "February 3, 2021",
    },
    {
        Institution: "freeCodeCamp",
        certificate: "Front End Development Libraries",
        logo: "https://i.imgur.com/1FWhJeT.png",
        Issued: "March 27, 2021",
    },
    {
        Institution: "freeCodeCamp",
        certificate: "Back End Development and APIs",
        logo: "https://i.imgur.com/1FWhJeT.png",
        Issued: "June 12, 2021",
    },
];